/**
 * Value Object — Email validado.
 * Regra puramente de domínio (sem dependência de framework).
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class Email {
  private constructor(public readonly value: string) {}

  static validate(input: string): { valid: true; email: Email } | { valid: false; reason: string } {
    const trimmed = input.trim();
    if (trimmed.length === 0) return { valid: false, reason: 'Email obrigatório' };
    if (trimmed.length > 254) return { valid: false, reason: 'Email muito longo' };
    if (!EMAIL_RE.test(trimmed)) return { valid: false, reason: 'Email inválido' };
    return { valid: true, email: new Email(trimmed.toLowerCase()) };
  }
}
